const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  bundleItemAdded: 'td-byob-added',
  bundleItemRemoved: 'td-byob-removed',
  bundleFiltered: 'td-byob-filtered',
  bundleFacetChanged: 'td-byob-facet-changed',
  bundleOpen: 'td-byob-open',
  bundleProductAdded: "td-byob-product-added",
  bundleProductRemoved: "td-byob-product-removed",
  bundleDiscountSet: 'td-byob-discount-set',
  bundleTierUpdate: "td-byob-tier-update",
  bundleGiftRevoked: 'td-byob-gift-removed',
  bundleGiftGranted: 'td-byob-gift-added',
  bundleAdded: 'td-byob-added',
  bundleEmptied: 'td-byob-emptied',
  sellingPlanUpdated: 'selling-plan-updated',
  cartUpdate: 'cart-update',
  cartUpdating: 'cart-updating',
};

let subscribers = {}

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = []
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback
    });
  }
};

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data)
    })
  }
}